var chunkMapping = {
	"src_react-app_bootstrap_ts-webpack_sharing_consume_default_react-dom_react-dom": [
		"webpack/container/remote/shared/url"
	],
	"webpack_container_remote_core_button": [
		"webpack/container/remote/core/button"
	],
	"webpack_container_remote_core_LinkNext": [
		"webpack/container/remote/core/LinkNext"
	],
	"webpack_container_remote_shared_headersignin": [
		"webpack/container/remote/shared/headersignin"
	],
	"webpack_container_remote_core_searchmodal": [
		"webpack/container/remote/core/searchmodal"
	],
	"webpack_container_remote_clp_FavoritesProductsCarousel": [
		"webpack/container/remote/clp/FavoritesProductsCarousel"
	],
	"webpack_container_remote_clp_SubVertical": [
		"webpack/container/remote/clp/SubVertical"
	],
	"webpack_container_remote_shared_CountrySelector": [
		"webpack/container/remote/shared/CountrySelector"
	],
	"webpack_container_remote_shared_StartTodayButton": [
		"webpack/container/remote/shared/StartTodayButton"
	],
	"webpack_container_remote_shared_headerbag": [
		"webpack/container/remote/shared/headerbag"
	],
	"webpack_container_remote_core_Footer_OrderLookupSection": [
		"webpack/container/remote/core/Footer/OrderLookupSection"
	],
	"webpack_container_remote_shared_LanguageSelector": [
		"webpack/container/remote/shared/LanguageSelector"
	],
	"webpack_container_remote_shared_StartTodayButtonBrandSite": [
		"webpack/container/remote/shared/StartTodayButtonBrandSite"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/shared/url": [
		"default",
		"./url",
		"webpack/container/reference/shared"
	],
	"webpack/container/remote/core/button": [
		"default",
		"./button",
		"webpack/container/reference/core"
	],
	"webpack/container/remote/core/LinkNext": [
		"default",
		"./LinkNext",
		"webpack/container/reference/core"
	],
	"webpack/container/remote/shared/headersignin": [
		"default",
		"./headersignin",
		"webpack/container/reference/shared"
	],
	"webpack/container/remote/core/searchmodal": [
		"default",
		"./searchmodal",
		"webpack/container/reference/core"
	],
	"webpack/container/remote/clp/FavoritesProductsCarousel": [
		"default",
		"./FavoritesProductsCarousel",
		"webpack/container/reference/clp"
	],
	"webpack/container/remote/clp/SubVertical": [
		"default",
		"./SubVertical",
		"webpack/container/reference/clp"
	],
	"webpack/container/remote/shared/CountrySelector": [
		"default",
		"./CountrySelector",
		"webpack/container/reference/shared"
	],
	"webpack/container/remote/shared/StartTodayButton": [
		"default",
		"./StartTodayButton",
		"webpack/container/reference/shared"
	],
	"webpack/container/remote/shared/headerbag": [
		"default",
		"./headerbag",
		"webpack/container/reference/shared"
	],
	"webpack/container/remote/core/Footer/OrderLookupSection": [
		"default",
		"./Footer/OrderLookupSection",
		"webpack/container/reference/core"
	],
	"webpack/container/remote/shared/LanguageSelector": [
		"default",
		"./LanguageSelector",
		"webpack/container/reference/shared"
	],
	"webpack/container/remote/shared/StartTodayButtonBrandSite": [
		"default",
		"./StartTodayButtonBrandSite",
		"webpack/container/reference/shared"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}